import { createFileRoute } from '@tanstack/react-router';
import { UserProfileByUsername } from '@/features/user-profile';

export const Route = createFileRoute('/_authenticated/$username/')({
    head: () => ({ meta: [{ title: 'Profile | promote.fun' }] }),
    component: UserProfileByUsername,
});
